import React, { useState } from 'react';
import './Dropdown.css';
import { getAuthToken } from '../utils/auth';

export default function ImportacaoProdutos({ apiBases = [], onClose, onImportSuccess }) {
  const [file, setFile] = useState(null);
  const [atualizarSeExistir, setAtualizarSeExistir] = useState(false);
  const [campoChave, setCampoChave] = useState('Nome');
  const [ignorarLinhasComErro, setIgnorarLinhasComErro] = useState(true);
  const [validarCodigoBarrasUnico, setValidarCodigoBarrasUnico] = useState(true);
  const [validarNomeUnico, setValidarNomeUnico] = useState(true);
  const [precoMinimo, setPrecoMinimo] = useState('');
  const [precoMaximo, setPrecoMaximo] = useState('');
  const [categoriaProdutoId, setCategoriaProdutoId] = useState('');
  const [loading, setLoading] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [previa, setPrevia] = useState(null);
  const [erro, setErro] = useState(null);

  const buildFormData = (includeFile = true) => {
    const formData = new FormData();
    if (includeFile && file) formData.append('Arquivo', file);
    formData.append('AtualizarSeExistir', atualizarSeExistir);
    formData.append('CampoChave', campoChave);
    formData.append('IgnorarLinhasComErro', ignorarLinhasComErro);
    formData.append('ValidarCodigoBarrasUnico', validarCodigoBarrasUnico);
    formData.append('ValidarNomeUnico', validarNomeUnico);
    if (precoMinimo) formData.append('PrecoMinimo', precoMinimo);
    if (precoMaximo) formData.append('PrecoMaximo', precoMaximo);
    if (categoriaProdutoId) formData.append('CategoriaProdutoId', categoriaProdutoId);
    return formData;
  }

  const tryFetch = async (path, options) => {
    const token = getAuthToken();
    const optionsWithAuth = { ...options, headers: { ...(options.headers || {}) } };
    if (token) optionsWithAuth.headers['Authorization'] = 'Bearer ' + token;
    for (const base of apiBases) {
      const url = `${base}ProdutoImportacao/${path}`;
      try {
        const res = await fetch(url, optionsWithAuth);
        if (res.ok) return res;
        const text = await res.text();
        console.warn('Resposta não OK:', res.status, text);
      } catch (err) {
        console.warn('Erro fetch', err.message);
      }
    }
    throw new Error('Nenhuma base de API respondeu com sucesso.');
  };

  const handleValidar = async () => {
    setErro(null);
    setResultado(null);
    setPrevia(null);
    if (!file) return setErro('Selecione um arquivo antes de validar.');
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('arquivo', file);
      const res = await tryFetch('validar', { method: 'POST', body: formData });
      const json = await res.json();
      setResultado(json);
    } catch (err) {
      setErro(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePrevia = async () => {
    setErro(null);
    setResultado(null);
    setPrevia(null);
    if (!file) return setErro('Selecione um arquivo antes de gerar pré-visualização.');
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('arquivo', file);
      const res = await tryFetch('previa', { method: 'POST', body: formData });
      const json = await res.json();
      setPrevia(json);
    } catch (err) {
      setErro(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleImportar = async () => {
    setErro(null);
    setResultado(null);
    if (!file) return setErro('Selecione um arquivo antes de importar.');
    setLoading(true);
    try {
      const formData = buildFormData(true);
      const res = await tryFetch('importar', { method: 'POST', body: formData });
      const json = await res.json();
      setResultado(json);
      if (json.Sucesso) {
        if (onImportSuccess) onImportSuccess(json);
      }
    } catch (err) {
      setErro(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadTemplate = async (type = 'excel') => {
    try {
      for (const base of apiBases) {
        const url = `${base}ProdutoImportacao/template/${type}`;
        try {
          const token = getAuthToken();
          const headers = token ? { 'Authorization': 'Bearer ' + token } : {};
          const res = await fetch(url, { headers });
          if (!res.ok) continue;
          const blob = await res.blob();
          const urlBlob = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = urlBlob;
          a.download = `template_produtos.${type === 'excel' ? 'xlsx' : 'csv'}`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(urlBlob);
          return;
        } catch (err) {
          console.warn('Erro ao baixar template', err.message);
        }
      }
      setErro('Não foi possível baixar o template.');
    } catch (err) {
      setErro(err.message);
    }
  };

  const botao = (fundo) => ({ background: fundo, color: '#fff', padding: '10px 18px', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 14, lineHeight: 1.2 });

  return (
    <div className="popup-agendamento-overlay" onClick={onClose} style={{ position: 'fixed', inset: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 95000, background: 'rgba(0,0,0,0.45)', padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ position: 'relative', width: 820, maxWidth: '100%', maxHeight: '90vh', overflowY: 'auto', background: '#fff', borderRadius: 12, padding: '22px 24px', boxShadow: '0 8px 30px rgba(0,0,0,0.25)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, marginBottom: 18 }}>
          <h3 style={{ margin: 0, color: 'rgb(235, 133, 0)', fontSize: 22 }}>Importar Produtos em Massa</h3>
          <button onClick={onClose} aria-label="Fechar" title="Fechar" style={{ flexShrink: 0, backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: '50%', width: 36, height: 36, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, lineHeight: 1, cursor: 'pointer' }}>×</button>
        </div>

        <div>
            <div style={{ marginBottom: 14, padding: 14, border: '2px dashed rgb(235, 133, 0)', borderRadius: 8, background: '#fffaf3' }}>
              <label style={{ display: 'block', fontWeight: 700, marginBottom: 8 }}>Arquivo (xlsx, csv, txt)</label>
              <input type="file" accept=".xlsx,.xls,.csv,.txt" onChange={e => setFile(e.target.files && e.target.files[0])} />
            </div>

            <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap', alignItems: 'center', marginBottom: 16, fontSize: 14 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                <input type="checkbox" checked={atualizarSeExistir} onChange={e => setAtualizarSeExistir(e.target.checked)} /> Atualizar se existir
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                Campo chave:
                <select value={campoChave} onChange={e => setCampoChave(e.target.value)} style={{ padding: '6px 8px', borderRadius: 6, border: '1px solid #ccc' }}>
                  <option value="Nome">Nome</option>
                  <option value="CodigoBarras">Código de barras</option>
                </select>
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                <input type="checkbox" checked={ignorarLinhasComErro} onChange={e => setIgnorarLinhasComErro(e.target.checked)} /> Ignorar linhas com erro
              </label>
            </div>

            <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                <button onClick={handleValidar} disabled={loading} style={botao('rgb(235, 133, 0)')}>Validar</button>
                <button onClick={handlePrevia} disabled={loading} style={botao('#1976d2')}>Pré-visualizar</button>
                <button onClick={handleImportar} disabled={loading} style={botao('#388e3c')}>Importar</button>
              </div>
              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                <button onClick={() => handleDownloadTemplate('excel')} style={botao('#616161')}>Baixar template Excel</button>
                <button onClick={() => handleDownloadTemplate('csv')} style={botao('#616161')}>Baixar template CSV</button>
              </div>
            </div>

            {loading && <div style={{ padding: 12 }}>Processando...</div>}
            {erro && <div style={{ color: '#d32f2f', padding: 8 }}>{erro}</div>}

            {resultado && (
              <div style={{ marginTop: 12, padding: 12, background: '#f5f5f5', borderRadius: 6 }}>
                <strong>Resultado:</strong>
                <div>Sucesso: {String(resultado.Sucesso)}</div>
                <div>Total registros: {resultado.TotalRegistros}</div>
                <div>Registros processados: {resultado.RegistrosProcessados}</div>
                <div>Registros com sucesso: {resultado.RegistrosComSucesso}</div>
                <div>Registros com erro: {resultado.RegistrosComErro}</div>
                {resultado.Erros && resultado.Erros.length > 0 && (
                  <div style={{ marginTop: 8 }}>
                    <strong>Erros:</strong>
                    <ul>
                      {resultado.Erros.map((e, i) => (
                        <li key={i}>Linha {e.Linha}: {e.Campo} - {e.Erro}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}

            {previa && previa.length > 0 && (
              <div style={{ marginTop: 12, padding: 12, background: '#fffde7', borderRadius: 6 }}>
                <strong>Pré-visualização (primeiros registros):</strong>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 8 }}>
                  <thead>
                    <tr style={{ textAlign: 'left', borderBottom: '1px solid #ddd' }}>
                      <th style={{ padding: 6 }}>Nome</th>
                      <th style={{ padding: 6 }}>Descrição</th>
                      <th style={{ padding: 6 }}>Preço</th>
                      <th style={{ padding: 6 }}>Estoque</th>
                    </tr>
                  </thead>
                  <tbody>
                    {previa.map((p, idx) => (
                      <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                        <td style={{ padding: 6 }}>{p.Nome}</td>
                        <td style={{ padding: 6 }}>{p.Descricao}</td>
                        <td style={{ padding: 6 }}>{p.Preco}</td>
                        <td style={{ padding: 6 }}>{p.EstoqueFisico}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
        </div>
      </div>
    </div>
  );
}
